// @flow
import React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
// $FlowFixMe - TS file
import env from 'bench-environment';

import InternalNotes from './InternalNotes';
import ClientCommentsContainer from './ClientCommentsContainer';
import JournalEntryCategorizationContainer from './JournalEntryCategorizationContainer';
import JournalEntryHistory from './JournalEntryHistory';
import JournalEntryInfoCard from './JournalEntryInfoCard';
import ThumbnailImage from './ThumbnailImage';
import type { JournalEntry, ClientComment, InternalNote, JournalEntryHistoryEntry } from './types';

const MetadataSection = styled.div`
  border-top: 1px solid ${colors.silt};
  margin-top: 16px;
  padding: 12px 16px;
`;

const MetadataItem = styled.div`
  color: ${colors.cloud};
  font-size: 11px;
  line-height: 1.6;
  margin: 6px 0;
`;

const MetadataLabel = styled.span`
  color: ${colors.cloud};
  display: inline-block;
  margin-right: 4px;
`;

const MetadataValue = styled.span`
  word-break: break-all;
`;

const MetadataList = styled.div`
  margin-top: 4px;
  padding-left: 16px;
`;

const MetadataListItem = styled.div`
  font-size: 10px;
  line-height: 1.4;
  margin: 2px 0;
`;

const AccountName = styled.span`
  font-style: italic;
`;

type JournalEntrySidebarProps = {
  amountInCents: number,
  clientCatResponse: ?string,
  clientComments: Array<ClientComment>,
  clientId: string,
  dismiss: () => void,
  historyEntries: Array<JournalEntryHistoryEntry>,
  internalNotes: Array<InternalNote>,
  journalEntry: JournalEntry,
  showJournalEntryEditForm: () => void,
  showClientRuleEditForm: () => void,
};

const JournalEntryContent = ({
  amountInCents,
  clientCatResponse,
  clientComments,
  clientId,
  dismiss,
  historyEntries,
  internalNotes,
  journalEntry,
  showJournalEntryEditForm,
  showClientRuleEditForm,
}: JournalEntrySidebarProps) => {
  const previewImage =
    journalEntry.file &&
    journalEntry.file.pagesCount > 0 &&
    `${env.location.apiRoot}${journalEntry.file.previewImages[0]}`;
  return (
    <div>
      <JournalEntryInfoCard
        {...{
          ...journalEntry,
          amountInCents,
          clientCatResponse,
          clientId,
          dismiss,
          showJournalEntryEditForm,
        }}
      />
      {previewImage && <ThumbnailImage alt="thumbnail of first page" src={previewImage} />}
      {journalEntry.categorizerMethod && (
        <JournalEntryCategorizationContainer
          categorizerMethod={journalEntry.categorizerMethod}
          journalEntryId={journalEntry.id}
          clientRuleId={journalEntry.categorizerRuleId}
          showClientRuleEditForm={showClientRuleEditForm}
        />
      )}
      <ClientCommentsContainer
        clientId={clientId}
        journalEntryId={journalEntry.id}
        clientComments={clientComments}
      />
      <InternalNotes
        clientId={clientId}
        internalNotes={internalNotes}
        journalEntryId={journalEntry.id}
      />
      <JournalEntryHistory historyEntries={historyEntries} />
      <MetadataSection>
        <MetadataItem>
          <MetadataLabel>Journal Entry ID:</MetadataLabel>
          <MetadataValue>{journalEntry.id}</MetadataValue>
        </MetadataItem>
        <MetadataItem>
          <MetadataLabel>Data Entries ({journalEntry.dataEntries.length}):</MetadataLabel>
          <MetadataList>
            {journalEntry.dataEntries.map(entry => (
              <MetadataListItem key={entry.id}>
                <MetadataValue>{entry.id}</MetadataValue>
                <AccountName> → {entry.ledgerAccount.name}</AccountName>
              </MetadataListItem>
            ))}
          </MetadataList>
        </MetadataItem>
      </MetadataSection>
    </div>
  );
};

export default JournalEntryContent;
